// extracted by mini-css-extract-plugin
export default {"noflag-text":"CountryFlag_noflag-text__3URPl"};